import { StyledLabelOnBox, StyledLabelText } from './style';

type Props = {
  isLiftStationMobile?: boolean;
};

export const StateLabelOnBox = ({ isLiftStationMobile }: Props) => (
  <StyledLabelOnBox isLiftStationMobile={isLiftStationMobile}>
    <StyledLabelText isLiftStationMobile={isLiftStationMobile}>On</StyledLabelText>
  </StyledLabelOnBox>
);
